var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogledrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "68px",
    viewBox: "0 0 98 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "googledrive",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.500000, 8.000000)",
    id: "Google_Drive_Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\uC791\\uC5C5\\uC2E43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google_Drive_Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_x0020_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#3777E3",
    points: "12.8341044 66.2532928 25.6664739 44.1688619 77 44.1688619 64.1664739 66.2532928"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFCF63",
    points: "51.3341044 44.1688619 77 44.1688619 51.3341044 0 25.6664739 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#11A861",
    points: "0 44.1688619 12.8341044 66.2532928 38.5 22.0844309 25.6664739 0"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogledrive);
export default __webpack_public_path__ + "static/media/googledrive.6216e154fa2ce2838fcfcb67001cad10.svg";
export { ForwardRef as ReactComponent };